import React from "react";
import styles from "./toggle-link.module.scss";
import Typography from "../typography/Typography";

type ToggleLinkProps = {
  linkText: string;
  handleClick: () => void;
  isDisabled?: boolean;
};

const ToggleLink = ({
  linkText,
  handleClick,
  isDisabled = false
}: ToggleLinkProps) => (
  <Typography variant="h5">
    <a
      onClick={!isDisabled ? handleClick : undefined}
      className={
        !isDisabled ? styles["toggle-link"] : styles["toggle-link-disabled"]
      }
    >
      {linkText}
    </a>
  </Typography>
);

export default ToggleLink;
